import { useParams, useSearchParams } from "react-router-dom";
import {
  useGetCandidateDetailsQuery,
  useGetJobRequestByIdQuery,
} from "../../../redux/Hire/jobRequestApi";
import Layout from "../../../shared/components/LayoutV2";
import JobBreadcrumbs from "../../JobRequest/JobBreadcrumbs";
import CandidateInfo from "./CandidateInfo";
import CandidateSubHeader from "./CandidateSubHeader";

type Props = {};

const CandidatePage = (props: Props) => {
  const [params] = useSearchParams();
  const { id } = useParams();
  const jobId = params.get("jobId");

  const { data: jobReqData } = useGetJobRequestByIdQuery(
    {
      jobRequestId: Number(jobId) || 0,
    },
    {
      skip: !jobId,
    },
  );
  const { data: candidateData } = useGetCandidateDetailsQuery(
    {
      id: id || "",
    },
    {
      skip: !id,
    },
  );

  return (
    <Layout
      header={
        <JobBreadcrumbs
          showBack={true}
          paths={[
            {
              label: jobReqData?.data?.title || "Job Request",
              to: `/job-request/${jobId}`,
            },
            {
              label: candidateData?.data?.name || "Candidate",
              to: "/candidates/new",
            },
          ]}
        />
      }
      subHeader={
        <CandidateSubHeader
          candidate={candidateData?.data}
          jobId={jobId || ""}
        />
      }
      body={
        <CandidateInfo candidate={candidateData?.data} job={jobReqData?.data} />
      }
    ></Layout>
  );
};

export default CandidatePage;
